import { getFancyboxButtonShareTpl } from 'components/FancyboxButtons/FancyboxButtonShare';
import SharingPopup from 'components/SharingPopup/SharingPopup';

import { renderToString } from 'react-dom/server';

export interface FancyBoxOptionsProps {
  uniqueId: string;
  shareUrl: string;
  image: string;
  title: string;
}

export interface FancyBoxProps {
  'data-fancybox': string;
  'data-options': string;
  'data-fancybox-trigger': string;
}

export function getFancyBoxOptions({ uniqueId, shareUrl, image, title }: FancyBoxOptionsProps): FancyBoxProps {
  const escapedTitle = title.replace(/"/g, '&quot;');
  const options = JSON.stringify({
    infobar: true,
    thumbs: { autoStart: true, axis: 'x' },
    baseClass: 'customBox',
    buttons: ['thumbs', 'share', 'close'],
    share: {
      tpl: renderToString(<SharingPopup url={shareUrl} image={image} title={title} />),
    },
    btnTpl: { share: getFancyboxButtonShareTpl() },
    iframe: {
      tpl: `<iframe id="fancybox-frame{rnd}" name="fancybox-frame{rnd}" class="fancybox-iframe" aria-label="${escapedTitle}" title="${escapedTitle}" allowfullscreen="allowfullscreen" allow="autoplay; fullscreen" src=""></iframe>`,
    },
  });

  return {
    'data-fancybox': uniqueId,
    'data-options': options,
    'data-fancybox-trigger': uniqueId,
  };
}
